import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToastAnimation } from '@mode/shared/util-toast';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'mode-report-run-progress',
  templateUrl: './report-run-progress.component.html',
  styleUrls: ['./report-run-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
})
export class ReportRunProgressComponent extends Toast {}
